import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormGroup
} from '@mui/material';
import './table.scss';
import { IconDataMap, IconEdit, IconView } from '../../../icons/Icon';
import { useState } from 'react';
import AddRoleModal from '../AddRoleModal';
import { useNavigate } from 'react-router-dom';

interface Role {
  roleid: number;
  rolename: string;
  isactive: string;
}

interface RolesTableData {
  roles: Role[];
  fetchRoles: () => void; 
}

const RoleConfigurationTable: React.FC<RolesTableData> = ({ roles, fetchRoles }) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [modalType, setModalType] = useState<'add' | 'edit' | 'view'>('add');
  const [selectedRole, setSelectedRole] = useState<Role | null>(null);
  const navigate = useNavigate();

  const handleOpenModal = (type: 'edit' | 'view', role: Role) => {
    setModalType(type);
    setSelectedRole(role);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedRole(null);
  };

  const handleOkModal = () => {
    setOpenModal(false);
    fetchRoles();  
    setSelectedRole(null);
  };

  return (
    <FormGroup className="table-wrapper RbacRoleTable">
      <TableContainer component={Paper} className="table-inner" sx={{ maxHeight: 422 }}>
        <MuiTable stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Role Id</TableCell>
              <TableCell>Role Name</TableCell>
              <TableCell>Is Active</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {roles.length !== 0 ? (
              roles.map((data: Role, index: number) => (
                <TableRow key={index}>
                  <TableCell>{data?.roleid}</TableCell>
                  <TableCell>{data?.rolename}</TableCell>
                  <TableCell>{data?.isactive}</TableCell>
                  <TableCell>
                    <div className="flex aligns-items-center">
                      <button className="ml-10" title="Edit" onClick={() => handleOpenModal('edit', data)}>
                        <IconEdit />
                      </button>
                      <button className="ml-10 view" title="View" onClick={() => handleOpenModal('view', data)}>
                        <IconView />
                      </button>
                      <button className={`ml-10 map ${data?.isactive==='N' ? "disabled" : ""}`} title="Map module" onClick={() => navigate(`/roleconfiguration/mapmodule/${data?.roleid}`)}>
                        <IconDataMap />
                      </button>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} className="grey-bg center">No data found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </MuiTable>
      </TableContainer>

      {openModal && (
          <AddRoleModal
            open={openModal}
            handleClose={handleCloseModal}
            handleOk={handleOkModal}
            title={modalType === 'edit' ? 'Edit Role' : modalType === 'view' ? 'View Role' : 'Add Role'}
            closeText="Cancel"
            submitText={modalType === 'view' ? undefined : 'Save'}
            singleBtn={modalType === 'view'}
            roleData={selectedRole ?? undefined}
            mode={modalType}
            roleList={roles} // Pass the full role list here
          />        
      )}
    </FormGroup>
  );
};

export default RoleConfigurationTable;
